module.exports = __webpack_public_path__ + "h5/img/model_bg_1.63cd3d06.png";